import { Grid } from '@mui/material'

export default function NorthwellLog () {
  return (
    <Grid item>
      <img src='/images/NorthwellHealthLogo.svg' alt='Northwell Health Logo' />
    </Grid>
  )
}
